import React from "react";
import Modal from "../Modal";

export default function TeamLeaveModal({ isOpen, onClose, onLeave }) {
  return (
    isOpen && (
      <Modal isOpen={isOpen} onClose={onClose}>
        <div className="text-center">
          <h2 className="text-lg font-semibold mb-4 text-gray-800 dark:text-gray-100">Leave Team</h2>
          <p className="mb-4 text-sm text-gray-600 dark:text-gray-300">
            Are you sure you want to leave this team? You will lose access to its members and resources.
          </p>
          <div className="flex justify-center gap-4 mb-2">
            <button
              className="px-4 py-2 rounded bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600 transition"
              onClick={onClose}
            >
              No
            </button>
            <button
              className="px-4 py-2 rounded bg-gradient-to-r from-gray-500 to-gray-800 text-white hover:from-gray-600 hover:to-gray-900 transition font-semibold"
              onClick={onLeave}
            >
              Yes
            </button>
          </div>
        </div>
      </Modal>
    )
  );
}
